import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';

@Pipe({
    name: 'organisationFilterPipe',
    pure: false,
    standalone: false
})
export class OrganisationFilterPipe implements PipeTransform {
  transform(organisations: { key: string; value: OrganisationDto }[], query: string): any {
    if (!organisations || !query || !query.length) {
      return organisations;
    }

    return organisations.filter((org) => {
      return (org.value.name?.toLowerCase() ?? '').includes(query.toLowerCase());
    });
  }
}
